import { createAppSearch, createPanelHeader } from './app-search.helpers';
import type { Panel } from '../controls/panel.mjs';
import EVENTS from '../events.mjs';
import classes from './app-search.module.scss';
import { create } from '../utils.mjs';

const SUPPORTED_MODULE_TYPES = ['transformer', 'action', 'search'];
const UNSUPPORTED_APPS = ['builtin', 'util', 'gateway'];

export async function openAppSearch(target: HTMLElement, parentForm: HTMLElement) {
	const appSearch = createAppSearch({
		showTopModules: false,
		showFavourites: false,
		showAppsInScenario: false,
		moduleFilter: (app, module) => {
			if (UNSUPPORTED_APPS.includes(app.name)) {
				return false;
			}

			if (!SUPPORTED_MODULE_TYPES.includes(module.type)) {
				return false;
			}

			return true;
		},
	});

	if (!appSearch) {
		return;
	}

	let resolve: (m: unknown | null) => void = () => {};
	const promise = new Promise((res) => {
		resolve = res;
	});

	let appPanel: Panel | null = create('imt-panel') as Panel;
	appPanel.parentForm = parentForm || {};

	appPanel.appendChild(
		createPanelHeader({
			title: 'App search',
			icon: 'fa-circle',
			onClose: () => {
				appPanel?.close();
			},
		}),
	);
	appPanel.body.appendChild(appSearch);
	appPanel.body.classList.add(classes.body, classes.overwriteAppSearchStyles);
	appPanel.height = '526px';
	appPanel.width = '396px';
	appPanel.position = ['right'];
	appPanel.relative = target;
	appPanel.classList.add('bg-white', 'ai-app-select');
	appPanel.open();

	appSearch.addEventListener('module-selected', (e) => {
		// Important! Needs to resolve before closing the panel
		resolve?.((e as { detail?: unknown }).detail);
		appPanel?.close();
	});

	appSearch.addEventListener('keydown', (e) => {
		if (e.key === 'ArrowUp') {
			appSearch?.preselectItem?.('previous');
		} else if (e.key === 'ArrowDown') {
			appSearch?.preselectItem?.('next');
		} else if (e.key === 'Enter') {
			appSearch?.selectItem?.();
		} else if (e.key === 'Escape') {
			if (appSearch?.detail?.isOpened && appSearch.closableDetail) {
				appSearch.detail.close?.();
				e.stopPropagation();
				e.preventDefault();
			} else {
				appPanel?.close();
			}
		}
	});

	appPanel.addEventListener(EVENTS.PANEL.CLOSE, () => {
		appPanel = null;
		resolve(null);
	});

	return await promise;
}
